/** Kannada: ಉಳಿಸಿದ ವಿಳಾಸಗಳು ಮತ್ತು ಈಗಿನ ಸ್ಥಳ (ADR 0045). */
export const address = {
    "addr.title": "ಉಳಿಸಿದ ವಿಳಾಸಗಳು",
    "addr.add": "ವಿಳಾಸ ಸೇರಿಸಿ",
    "addr.none": "ಇನ್ನೂ ಯಾವ ವಿಳಾಸವೂ ಉಳಿಸಿಲ್ಲ.",
    "addr.private": "ಒಪ್ಪಂದಕ್ಕೆ ಇಬ್ಬರೂ ಸಹಿ ಹಾಕುವವರೆಗೆ ಕೆಲಸಗಾರರಿಗೆ ನಿಮ್ಮ ಏರಿಯಾ ಮಾತ್ರ ಕಾಣುತ್ತದೆ. ಪೂರ್ಣ ವಿಳಾಸ ನೀವು ಒಪ್ಪಂದ ಮಾಡಿಕೊಳ್ಳುವ ಕೆಲಸಗಾರರಿಗೆ ಮಾತ್ರ.",
    "addr.use_location": "ನನ್ನ ಈಗಿನ ಸ್ಥಳ ಬಳಸಿ",
    "addr.why_title": "ನಿಮ್ಮ ಸ್ಥಳ ಬಳಸಬೇಕೇ?",
    "addr.why": "ನಿಮ್ಮ ಏರಿಯಾ, ನಗರ ಮತ್ತು ಪಿನ್ ಕೋಡ್ ತುಂಬಲು GigSync ನಿಮ್ಮ ಫೋನ್‌ಗೆ ನೀವು ಎಲ್ಲಿದ್ದೀರಿ ಎಂದು ಒಮ್ಮೆ ಕೇಳುತ್ತದೆ. ಸುಮಾರು ಒಂದು ಕಿಲೋಮೀಟರ್‌ನ ಸ್ಥೂಲ ಸ್ಥಳ ಮಾತ್ರ ಫೋನ್‌ನಿಂದ ಹೊರಗೆ ಹೋಗುತ್ತದೆ, ಮತ್ತು ಸಹಿಗೆ ಮೊದಲು ಕೆಲಸಗಾರರಿಗೆ ನಿಮ್ಮ ಏರಿಯಾ ಮಾತ್ರ ಕಾಣುತ್ತದೆ.",
    "addr.allow": "ಮುಂದುವರಿಸಿ",
    "addr.not_now": "ಈಗ ಬೇಡ",
    "addr.locating": "ನಿಮ್ಮ ಏರಿಯಾ ಹುಡುಕುತ್ತಿದೆ…",
    "addr.denied": "GigSync‌ಗೆ ಸ್ಥಳ ಆಫ್ ಆಗಿದೆ. ವಿಳಾಸ ಹುಡುಕಿ ಅಥವಾ ಬರೆಯಿರಿ.",
    "addr.failed": "ನಿಮ್ಮ ಏರಿಯಾ ಸಿಗಲಿಲ್ಲ. ಹುಡುಕಿ ಅಥವಾ ಬರೆಯಿರಿ.",
    "addr.found": "ನೀವು {area} ಏರಿಯಾದಲ್ಲಿದ್ದೀರಿ. ವಿವರ ನೋಡಿ, ಮನೆ ಅಥವಾ ಫ್ಲ್ಯಾಟ್ ಸಂಖ್ಯೆ ಸೇರಿಸಿ.",
    "addr.search": "ನಿಮ್ಮ ಏರಿಯಾ ಅಥವಾ ಕಟ್ಟಡ ಹುಡುಕಿ",
    "addr.find": "ಹುಡುಕಿ",
    "addr.search_none": "ಏನೂ ಸಿಗಲಿಲ್ಲ. ಕೆಳಗೆ ವಿಳಾಸ ಬರೆಯಿರಿ.",
    "addr.search_off": "ಹುಡುಕಾಟ ಈಗ ಲಭ್ಯವಿಲ್ಲ. ಕೆಳಗೆ ವಿಳಾಸ ಬರೆಯಿರಿ.",
    "addr.house": "ಮನೆ ಅಥವಾ ಫ್ಲ್ಯಾಟ್ ಸಂಖ್ಯೆ",
    "addr.floor": "ಮಹಡಿ (ಬೇಕಾದರೆ)",
    "addr.building": "ಕಟ್ಟಡ ಅಥವಾ ಸೊಸೈಟಿ (ಬೇಕಾದರೆ)",
    "addr.street": "ರಸ್ತೆ (ಬೇಕಾದರೆ)",
    "addr.landmark": "ಹತ್ತಿರದ ಗುರುತು (ಬೇಕಾದರೆ)",
    "addr.area": "ಏರಿಯಾ",
    "addr.city": "ನಗರ",
    "addr.pin": "ಪಿನ್ ಕೋಡ್",
    "addr.label": "ಈ ಹೆಸರಿನಲ್ಲಿ ಉಳಿಸಿ",
    "addr.label.home": "ಮನೆ",
    "addr.label.work": "ಕಚೇರಿ",
    "addr.label.other": "ಬೇರೆ",
    "addr.save": "ವಿಳಾಸ ಉಳಿಸಿ",
    "addr.check_pin": "ಪಿನ್ ನಿಮ್ಮ ಬಾಗಿಲಿನ ಮೇಲಿದೆಯೇ? ನಕ್ಷೆಯನ್ನು ಸರಿಸಿ ಅದನ್ನು ಬಾಗಿಲಿಗೆ ತನ್ನಿ, ನಂತರ ವಿಳಾಸ ಉಳಿಸಿ ಒತ್ತಿ.",
    "addr.cancel": "ರದ್ದುಮಾಡಿ",
    "addr.err_pin": "ಪಿನ್ ಕೋಡ್ ಆರು ಅಂಕಿಗಳದ್ದು.",
    "addr.err_missing": "ಮನೆ ಅಥವಾ ಫ್ಲ್ಯಾಟ್ ಸಂಖ್ಯೆ, ಏರಿಯಾ, ನಗರ ಮತ್ತು ಪಿನ್ ಕೋಡ್ ತುಂಬಿ.",
    "addr.near": "GigSync ಈ ವಿಳಾಸವನ್ನು ಗುರುತಿಸಲಾಗಲಿಲ್ಲ. ಇದು ಈ ಏರಿಯಾಗಳಲ್ಲಿ ಯಾವುದಕ್ಕೆ ಹತ್ತಿರ?",
    "addr.remove": "ತೆಗೆದುಹಾಕಿ",
    "addr.not_served": "ಕ್ಷಮಿಸಿ! ನಾವು ಇನ್ನೂ ನಿಮ್ಮ ಪ್ರದೇಶದಲ್ಲಿ ಇಲ್ಲ, ಆದರೆ ಅದಕ್ಕಾಗಿ ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದೇವೆ.",
    "addr.desk": "ನಿಮ್ಮ ವಿಳಾಸಗಳು. ಬಳಸಲು ಒಂದನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ, ಅಥವಾ ಹೊಸದನ್ನು ಸೇರಿಸಿ.",
    "addr.desk_none": "ಇನ್ನೂ ಯಾವ ವಿಳಾಸವೂ ಉಳಿಸಿಲ್ಲ. ಒಂದನ್ನು ಸೇರಿಸಿ, ಅಥವಾ ಈಗ ಇರುವ ಸ್ಥಳ ಬಳಸಿ.",
    "addr.new": "ಹೊಸ ವಿಳಾಸ ಸೇರಿಸಿ",
    "addr.using": "ಬಳಸುತ್ತಿರುವುದು: {label}, {area}",
    "addr.header": "ಬಳಸುತ್ತಿರುವ ವಿಳಾಸ: {label}, {area}. ಬದಲಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ.",
    "addr.header_none": "ನಿಮ್ಮ ವಿಳಾಸ ಸೇರಿಸಿ",
    "addr.done": "ಆಯಿತು",
    "map.move_pin": "ನಕ್ಷೆಯನ್ನು ಸರಿಸಿ ಪಿನ್ ಅನ್ನು ಬಾಗಿಲಿನ ಮೇಲೆ ತನ್ನಿ",
    "map.of": "{place} ನಕ್ಷೆ",
    "map.directions": "ದಾರಿ ನೋಡಿ",
    "addr.chip": "{label} · {area}",
    "addr.max": "ನೀವು ಗರಿಷ್ಠ {max} ವಿಳಾಸ ಇಟ್ಟುಕೊಳ್ಳಬಹುದು. ಹೊಸದನ್ನು ಸೇರಿಸಲು ಒಂದನ್ನು ತೆಗೆಯಿರಿ.",
    "need.ask.address": "ಕೆಲಸ ಎಲ್ಲಿ ಆಗಬೇಕು?",
    "need.ask.address_in": "{area} ನಲ್ಲಿ ಕೆಲಸಗಾರ ಯಾವ ವಿಳಾಸಕ್ಕೆ ಬರಬೇಕು?",
    "card.area_choose": "ನಿಮ್ಮ ಪ್ರದೇಶ ಆರಿಸಿ",
    "card.use_location": "ನನ್ನ ಏರಿಯಾಗೆ ನನ್ನ ಸ್ಥಳ ಬಳಸಿ",
    "card.area_found": "ನಿಮ್ಮ ಏರಿಯಾ: {area}",
};
//# sourceMappingURL=address.js.map